import { render } from "./infoModal.vue?vue&type=template&id=b749699c&scoped=true"
import script from "./infoModal.vue?vue&type=script&lang=js"
export * from "./infoModal.vue?vue&type=script&lang=js"

import "./infoModal.vue?vue&type=style&index=0&id=b749699c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b749699c"]])

export default __exports__